module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_05_1280_1280_zh-hant-0e7bb74c2d743a19860d5df3c2095a1e.jpg";